import { Stack } from '@mui/material';

import { DateRangePickerField } from '~/components/ui/date-picker';
import { useDashoardFilter } from '~/Page/customer/customerDashboard';

const ReportTopFilter = () => {
  const form = useDashoardFilter();
  return (
    <Stack direction='column' alignItems='flex-end' flexGrow={1} gap={2.5}>
      <div className='bg-white w-64'>
        <DateRangePickerField control={form.control} field='date_range' />
      </div>
    </Stack>
  );
};

export default ReportTopFilter;
